import ProductDetail from './ProductDetail';

export default ProductDetail;


// WEBPACK FOOTER //
// ./src/components/ProductDetail/index.tsx